var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2093 4.01092L12.4412 6.49501C12.6092 6.84081 13.0571 7.17249 13.4351 7.236L15.6679 7.61003C17.0957 7.84997 17.4317 8.89442 16.4028 9.92475L14.667 11.6749C14.373 11.9713 14.212 12.5429 14.303 12.9522L14.7999 15.1187C15.1919 16.8336 14.289 17.497 12.7842 16.6007L10.6914 15.3516C10.3134 15.1258 9.69051 15.1258 9.30556 15.3516L7.21279 16.6007C5.71495 17.497 4.80505 16.8266 5.19701 15.1187L5.69395 12.9522C5.78494 12.5429 5.62396 11.9713 5.33 11.6749L3.59419 9.92475C2.5723 8.89442 2.90126 7.84997 4.32911 7.61003L6.56186 7.236C6.93282 7.17249 7.38077 6.84081 7.54875 6.49501L8.78061 4.01092C9.45254 2.66303 10.5444 2.66303 11.2093 4.01092Z",
    fill: "#F5CE3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c0388704b2f38396219bd1f5d3802ae6.svg";
export { ForwardRef as ReactComponent };